module.exports = __webpack_public_path__ + "img/Banner_Licitacion-Recuperado.e360d658.jpg";